module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1286.7eb147a2.png";